import React from "react";
import {observer} from "mobx-react-lite";
import {useNavigate} from "react-router";
import clubStore from "../../../storage/ClubStore";
import appStore from "../../../storage/AppStore";
import systemStore from "../../../storage/SystemStore";
import Input from "../../../ui/Input";
import Select from "../../../ui/Select";
import Btn from "../../../ui/Btn";
import CheckBox from "../../../ui/CheckBox";
import PageLayout from "../../PageLayout";
import {getProduct} from "../../../common/config";

const Team = () => {
    const navigate = useNavigate();
    const product = getProduct();
    const isEdit = clubStore.team.id > 0;

    const handleSave = () => {
        clubStore.saveTeam()
            .then(() => {
                systemStore.setSuccess(appStore.tr.successfully_saved);
                navigate("/manager/team/list");
            })
            .catch((error) => {
                if (error) systemStore.setError(appStore.tr[error.message] || error.message);
            });
    };

    return (
        <PageLayout
            header={
                <div className="flex justify-content-between align-items-center w-full">
                    <div>
                        <h3 className="m-0">
                            {isEdit ? clubStore.team.name : appStore.tr.add_team}
                        </h3>
                        {isEdit && clubStore.team.sport?.name && (
                            <div className="text-600 mt-1">
                                {clubStore.team.sport?.icon} {clubStore.team.sport.name}
                            </div>
                        )}
                    </div>
                    <Btn
                        icon="pi pi-arrow-left"
                        severity="secondary"
                        outlined
                        onClick={() => navigate("/manager/team/list")}
                    />
                </div>
            }
        >
            <div className="secondary-card">
                <div className="flex align-items-center mb-3">
                    <i className="pi pi-users text-primary mr-2"/>
                    <b>{appStore.tr.main_information || appStore.tr.information}</b>
                </div>

                <div className="grid">
                    <div className="col-12 md:col-6">
                        <Input
                            id="input_name"
                            store={clubStore.team}
                            prop="name"
                            label={appStore.tr.name}
                            required
                        />
                    </div>
                    <div className="col-12 md:col-6">
                        <Select
                            id="select_club"
                            store={clubStore.team}
                            prop="company_id"
                            label={appStore.tr.club_branch}
                            options={clubStore.club.relatives}
                            required
                        />
                    </div>
                    <div className="col-12 md:col-6">
                        <Select
                            id="select_sport"
                            store={clubStore.team}
                            prop="sport_id"
                            label={product === "club1" ? appStore.tr.sport : appStore.tr.course}
                            options={clubStore.team.sports}
                            itemTemplate={(item) => `${item.icon} ${item.name}`}
                            valueTemplate={(item) => item ? `${item.icon} ${item.name}` : null}
                            required
                        />
                    </div>
                    <div className="col-12 md:col-6">
                        <div className="p-inputgroup">
                            <Input
                                id="input_fee"
                                type="number"
                                store={clubStore.team}
                                prop="fee"
                                label={appStore.tr.fee}
                            />
                            <span className="p-inputgroup-addon">
                                {clubStore.club.country.currency_sign}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="secondary-card mt-3">
                <div className="flex align-items-center mb-3">
                    <i className="pi pi-calendar text-primary mr-2"/>
                    <b>{product === "club1" ? appStore.tr.class_schedule : appStore.tr.lesson_schedule}</b>
                </div>

                <div className="flex flex-column gap-2">
                    {clubStore.team.schedule?.days?.map((day, index) => (
                        <div
                            key={index}
                            className={`grid align-items-center border-bottom-1 surface-border py-2 ${day.is_on ? "" : "text-500"}`}
                        >
                            <div className="col-12 md:col-4">
                                <CheckBox
                                    store={day}
                                    prop="is_on"
                                    label={day.is_on
                                        ? <b>{appStore.tr[day.name]}</b>
                                        : <span>{appStore.tr[day.name]}</span>
                                    }
                                    onChange={(checked) => {
                                        if (!checked) {
                                            day.setProperty("time_from", null);
                                            day.setProperty("time_to", null);
                                        }
                                    }}
                                />
                            </div>
                            <div className="col-6 md:col-4">
                                <Select
                                    store={day}
                                    prop="time_from"
                                    label={appStore.tr.beginning}
                                    options={clubStore.team.schedule.time}
                                    disabled={!day.is_on}
                                    small
                                />
                            </div>
                            <div className="col-6 md:col-4">
                                <Select
                                    store={day}
                                    prop="time_to"
                                    label={appStore.tr.end}
                                    options={clubStore.team.schedule.time}
                                    disabled={!day.is_on}
                                    small
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="flex justify-content-end mt-3">
                <Btn
                    icon="pi pi-save"
                    severity="success"
                    label={appStore.tr.save || (isEdit ? appStore.tr.edit : appStore.tr.add_team)}
                    onClick={handleSave}
                />
            </div>
        </PageLayout>
    );
};

export default observer(Team);